import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';
import userApi from '~/apis/user';

import { GET_PROFILE, LOGIN } from '~/utils/constants/actionType';
import { IBodyLogin } from '~/utils/interface/auth';

export const handleLogin = createAsyncThunk(
  LOGIN,
  async (
    payload: {
      body: IBodyLogin;
    },
    { rejectWithValue }
  ) => {
    try {
      const resp = await authApi.login(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getProfile = createAsyncThunk(GET_PROFILE, async (_: void, { rejectWithValue }) => {
  try {
    const resp = await userApi.getProfile();
    return resp.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
